import ConsumptionPage from './ConsumptionPage.component';

export default ConsumptionPage;
